import React from 'react';

import { Box, Text } from '@clutter/clean';

import { LocationLinksQuery } from '@graphql/platform';

import { routeURL } from '@root/components/locations/routes';

import { LocationLinksLayout } from './location_links_layout';

export const RouteLinks: React.FC<{
  routes: LocationLinksQuery['routes'];
}> = ({ routes }) => {
  return (
    <Box textAlign="center">
      <Box margin="0 0 72px">
        <Text.Title size="large" tag="h2">
          Popular Long-Distance Moving Routes
        </Text.Title>
      </Box>
      <LocationLinksLayout>
        {routes.map((route) => (
          <LocationLinksLayout.Link key={route.id} to={routeURL(route.slug)}>
            {route.origin.name} to {route.destination.name}
          </LocationLinksLayout.Link>
        ))}
      </LocationLinksLayout>
    </Box>
  );
};
